// Create a CustomerContext.js file
import React from 'react';

// Create the CustomerContext
const CustomerContext = React.createContext();

// Create a CustomerProvider component to provide the user value
const CustomerProvider = ({ children, value }) => {
    const customer = value === null ? null : value.customer;
    const [changed, setChanged] = React.useState(null);
    function isClient() {
        try {
            if (customer === null) {
                return false;
            } else {
                return customer.client !== undefined;
            }
        } catch {
            return null;
        }
    }

    function customerContextChanged() {
        setChanged(new Date());
    }

    function isCharity() {
        try {
            if (customer === null) {
                return false;
            } else {
                return customer.donation_configurations.length > 0;
            }
        } catch {
            return null;
        }
    }

    // Include the functions in the context value
    const contextValue = {
        customer,
        isClient,
        isCharity,
        customerContextChanged
    };

    return (
        <CustomerContext.Provider value={contextValue}>
            {children}
        </CustomerContext.Provider>
    );
};

export { CustomerContext, CustomerProvider };